export default "__VITE_ASSET__07fa6542__"